import React, { Component } from "react";
import { connect } from "react-redux";
import { I18n } from "react-redux-i18n";
import styled from "styled-components";
import { initLocale } from "store/actions/localeActions";

const ErrorWrapper = styled.div`
  display: flex;
  width: 100%;
  height: 100vh;
  align-items: center;
  justify-content: center;
`;

const FlexContainer = styled.div`
  display: flex;
  align-items: center;
  div {
    max-width: 300px;
    margin-right: 40px;
    &:last-child {
      margin-right: 0;
    }

    p,
    h1,
    h2 {
      margin: 0;
      padding: 0;
      letter-spacing: 1px;
    }

    h1 {
      font-size: 132px;
      color: #b6b6b6;
    }

    h2 {
      font-size: 62px;
      color: #505050;
      margin-bottom: 15px;
    }

    p {
      font-size: 18px;
      color: #222222;
      line-height: 22px;
      margin-bottom: 35px;
    }

    img {
      max-width: 110px;
      margin-bottom: 15px;
    }
  }
`;

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loaded: false,
      hasError: !!props.error,
    };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentWillMount() {
    const { locale, initLocale } = this.props;
    if (!locale) {
      initLocale(null, () => {
        this.setState({ loaded: true });
      });
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.error) {
      console.log(nextProps.error);
      this.setState({ hasError: true });
    }
  }

  componentDidCatch(error, info) {
    console.error(error, info);
    this.setState({ hasError: true });
  }

  render() {
    const { hasError, loaded } = this.state;
    const { children } = this.props;
    if (!loaded) return null;

    if (hasError) {
      return (
        <ErrorWrapper>
          <FlexContainer>
            <div>
              <h1>{I18n.t("error.title")}</h1>
            </div>
            <div>
              <img
                alt="Prosite Logo"
                src="https://storage.alboompro.com/products/v2/alboom_prosite.svg"
              />
              <h2>{I18n.t("error.subtitle")}</h2>
              <p>{I18n.t("error.details")}</p>
              <a href="https://prosite.alboompro.com/content/custom_pages">
                {I18n.t("error.link")}
              </a>
            </div>
          </FlexContainer>
        </ErrorWrapper>
      );
    }
    return children;
  }
}

const mapStateToProps = (state) => ({
  locale: state.i18n.locale,
  error: state.editor.error,
});

const mapDispatchToProps = {
  initLocale,
};

export default connect(mapStateToProps, mapDispatchToProps)(ErrorBoundary);
